import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useAlbumsPhotos from "./hooks/useAlbumsPhotos";

import AlbumsHeader from "./components/AlbumsHeader";
import AlbumsStats from "./components/AlbumsStats";
import AlbumsTable from "./components/AlbumsTable";
import AlbumFormDrawer from "./components/AlbumFormDrawer";
import PhotosManagerDrawer from "./components/PhotosManagerDrawer";

const AlbumsPhotos = ({ sectionId }) => {
  const {
    finalSectionId,
    rows,
    stats,
    loading,
    saving,
    demoMode,

    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,

    drawer,
    selectedAlbum,

    openCreateDrawer,
    openEditDrawer,
    openPhotosDrawer,
    closeDrawer,

    fetchAlbums,
    handleCreate,
    handleUpdate,
    handleDelete,
    handleAddPhoto,
    handleDeletePhoto,
  } = useAlbumsPhotos(sectionId);

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5">
        <AlbumsHeader
          loading={loading}
          demoMode={demoMode}
          sectionId={finalSectionId}
          onRefresh={fetchAlbums}
          onCreate={openCreateDrawer}
        />

        <AlbumsStats stats={stats} />

        <AlbumsTable
          rows={rows}
          loading={loading}
          searchTerm={searchTerm}
          statusFilter={statusFilter}
          onSearchChange={setSearchTerm}
          onStatusFilterChange={setStatusFilter}
          onEdit={openEditDrawer}
          onManagePhotos={openPhotosDrawer}
          onDelete={handleDelete}
        />
      </div>

      <AlbumFormDrawer
        isOpen={drawer.type === "create"}
        mode="create"
        saving={saving}
        onClose={closeDrawer}
        onCreate={handleCreate}
      />

      <AlbumFormDrawer
        isOpen={drawer.type === "edit"}
        mode="edit"
        album={selectedAlbum}
        saving={saving}
        onClose={closeDrawer}
        onUpdate={handleUpdate}
      />

      <PhotosManagerDrawer
        isOpen={drawer.type === "photos"}
        album={selectedAlbum}
        saving={saving}
        onClose={closeDrawer}
        onAddPhoto={handleAddPhoto}
        onDeletePhoto={handleDeletePhoto}
      />

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
};

export default AlbumsPhotos;